import axios from "axios";
import {toast} from "../class/Notification";
import CommentFilter from "../class/CommentFilter";
import CommentStatus from "../class/CommentStatus";


export const flatComment = (arr) => {
    return arr.reduce((a, item) => {
        a.push(item);
        if (item.replies) {
            a = a.concat(flatComment(item.replies));
        }
        return a;
    }, []);
};

export default {
    namespaced: true,
    state: {
        comments: [],
        productComments: [],
        meta: [],
        trash: [],
        trashMeta: []
    },
    mutations: {
        setComments(state, comments) {
            state.comments = comments
        },
        setMeta(state, meta) {
            state.meta = meta
        },
        setClientComment(state, comment) {
            state.clientComment = comment
        },
        setClientCommentMeta(state, meta) {
            state.clientCommentMeta = meta
        },
        setTrash(state, comment) {
            state.trash = comment
        },
        setTrashMeta(state, meta) {
            state.trashMeta = meta
        },
        setProductComments(state, comments) {
            state.productComments = comments
        }
    },
    actions: {
        getComments({commit}, form, page = 1) {

            axios
                .get(`/comments/dashboard/comment-type/${form.comment_type}/status/${form.status}?page=${form.page}`)
                .then((res) => {
                    const comments = res.data.data;
                    commit("setComments", comments.data);
                    commit("setMeta", comments.meta)
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getClientComments({commit}, {form, page = 1}) {
            axios
                .get(`/comments/${form.id}/comment-type/${form.comment_type}?page=${page}`)
                .then((res) => {
                    const comment = res.data.data;
                    if (form.comment_type === 'product') {
                        commit("setProductComments", comment.data);
                    } else {
                        commit("setComments", comment.data);
                    }
                    commit("setMeta", comment.meta)
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getTrash({commit}, page = 1) {

            axios
                .post(`/comments/trash?page=${page}`)
                .then((res) => {
                    const response = res.data.data
                    const comment = res.data.data.data;
                    commit("setTrash", comment);
                    commit("setTrashMeta", response.meta)
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        removeComment({commit}, form) {

            axios
                .delete(`/comment/${form.id}`)
                .then((res) => {
                    this.dispatch("Comment/getComments", {
                        comment_type: form.commentable_type,
                        status: form.status,
                        page: 1
                    })
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        updateComment({commit}, form) {
            if (this.getters["User/isAdmin"]) {

                axios
                    .put(`/comment/${form.id}`, {status: form.status})
                    .then(res => {
                        let loadForm = {comment_type: form.commentable_type, status: form.previous_status, page: 1}
                        this.dispatch("Comment/getComments", loadForm)
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        },
        restoreComment({commit}, commentId) {

            axios
                .put(`/comments/${commentId}/restore`)
                .then(res => {
                    this.dispatch("Comment/getTrash")
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        forceDelete({commit}, commentId) {

            axios
                .delete(`/comments/${commentId}/force-delete`)
                .then(res => {

                    this.dispatch("Comment/getTrash")
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        createComment({commit}, form) {

            axios
                .post(`/comment`, form)
                .then(res => {
                    toast('کامنت با موفقیت ثبت شد', 'کامنت با موفقیت ثبت شد')
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getUserCommentsWithoutState({commit}, form) {
            // origin method: getClientComments
            return axios.get(`/comments/${form.id}/comment-type/${form.type}?page=${form.page}`)
        },
        getProductCommentsWithoutState({commit}, form) {
            return axios.get(`product/${form.id}/comments?page=${form.page}`)
        },
    },
    getters: {
        getComments: (state) => state.comments,
        getMeta: (state) => state.meta,
        getTrash: (state) => state.trash,
        getTrashMeta: (state) => state.trashMeta,
        getProductComments: (state) => state.productComments
    },
}
